import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import Button from '../../../Button';
import styles from '../styles.less';

const PopoverFilter = ({ placement, content, active, title }) => {
  const [visible, setVisible] = React.useState(false);

  const handleVisibleChange = value => {
    setVisible(value);
  };

  return (
    <Popover
      trigger="click"
      content={content}
      visible={visible}
      placement={placement}
      onVisibleChange={handleVisibleChange}
    >
      <Button type="secondary" className={active || visible ? styles.active : null}>
        {title}
      </Button>
    </Popover>
  );
};

PopoverFilter.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.any,
  active: PropTypes.bool,
};

PopoverFilter.defaultProps = {
  placement: 'bottom',
  content: null,
  active: false,
};

export default PopoverFilter;
